import React from 'react';

function About() {
  return (
    <section id="about" className="about py-16 px-6 text-center bg-white">
      <h2 className="text-3xl font-semibold mb-4">About Me</h2>
      <p className="text-gray-600 max-w-xl mx-auto">I am a second-year BCA student with a passion for web development. I enjoy creating interactive and user-friendly websites while continuously exploring and mastering modern frameworks like React.js and Vue.js.</p>
    </section>
  );
}

export default About;